// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button__Button___22Ayz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Button/Button.scss
// module id = 1383
// module chunks = 0